import { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { getContent } from '../../../sdk/services/contentService';
import { LoggerService } from '../../utils';
import styles from './Footer.module.scss';


type FooterProps = {
  campaignId: string | null;
};

interface FooterType {
  text: string;
  privacy_and_policy: {
    title: string;
    href: string;
  };
  terms_and_conditions: {
    title: string;
    href: string;
  };
  amway: {
    amway_link: {
      title: string;
      href: string;
    };
    amway_logo: {
      url: string;
    };
  };
  dsam: {
    dsam_link: {
      title: string;
      href: string;
    };
    dsam_logo: {
      url: string;
    };
  };
}

export const Footer: React.FC<FooterProps> = ({ campaignId }) => {
  const [content, setContent] = useState<FooterType>();

  const cacheKey = 'footerContent';

  useEffect(() => {
    const fetchFooterContent = async () => {
      try {
        const data = await getContent('footer', cacheKey, true);
        setContent(data);
      } catch (error) {
        LoggerService.log('Failed to retrieve footer content data. Using default content.');
      }
    };

    fetchFooterContent();
  }, []);

  return (
    <footer className={styles['footer']}>
      <div className={styles['footer-container']}>
        <div className={styles['footer-left']}>{content?.text}</div>
        <div className={styles['footer-right']}>
          <a
            href={content?.privacy_and_policy?.href}
            target="_blank"
            rel="noreferrer"
            className={styles['footer-privacy']}
          >
            {content?.privacy_and_policy?.title}
          </a>
          <div>|</div>
          <a
            href={campaignId? content?.terms_and_conditions?.href  + '?cid=' + campaignId : content?.terms_and_conditions?.href}
            target="_blank"
            rel="noreferrer"
            className={styles['footer-terms']}
          >
            {content?.terms_and_conditions?.title}
          </a>
        </div>
      </div>
      <div className={styles['logo-container']}>
        <a
          target="_blank"
          rel="noreferrer"
          href={content?.amway?.amway_link.href}
          className={styles['logo-container-content']}
        >
          <img width={'35px'} src={content?.amway?.amway_logo?.url} alt={''} />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href={content?.dsam?.dsam_link.href}
          className={styles['logo-container-content']}
        >
          <img width={'35px'} src={content?.dsam?.dsam_logo?.url} alt={''} />
        </a>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  campaignId: PropTypes.string, // null is allowed too
};